export const ELECTIONS_TAB_TEST_ID = 'elections-tab-test-id';
export const PRODUCT_LINE_RATE_MODAL_TEST_ID = 'product-line-rate-modal-test-id';

export const FULL_FORM_TABS_TEST_ID = 'full-form-tabs-test-id';
export const FULL_FORM_SPINNER_TEST_ID = 'full-form-spinner-test-id';
